import { ValidationState } from '@components/common/types';
import { StepsStore } from '@stores/common/stepsStore';
import { StepStore } from '@stores/common/stepStore';
import { IRootStore } from '@stores/index';
import { AudienceConfigurationStore } from '../../../common/audienceConfiguration/stores/audienceConfiguration';

export enum PROFILE_SOURCE_TYPES {
  'Table' = 'profiles-table',
  'Audience' = 'profiles-audience',
}

export type SourceDefinitionType = 'snowflake' | 'bigquery' | 'redshift' | 'databricks';

export interface ActivationDetails {
  name: string;
  identifier?: string;
  whtProjectId: string;
  sourceDefName?: SourceDefinitionType;
  sourceDefDisplayName?: SourceDefinitionType;
  entityId: string;
  cohortId: string;
  type?: PROFILE_SOURCE_TYPES;
}

export interface Identifier {
  name: string;
  model_type: string;
  entity_key: string;
  path_ref: string;
  warehouse_view_name: string;
  cohort_path_ref: string;
  trait_360_id_column_name: string;
}

export interface ActivationDetailsStoreType extends StepStore<ActivationStoreType> {
  activationDetails: ActivationDetails;
  isDataLoading: boolean;
  saveLabel: string;
  activationIdentifiers?: Identifier[];
  updateValidationState: (value: ValidationState) => void;
  validationState: ValidationState;
  updateActivationType: (value: PROFILE_SOURCE_TYPES) => void;
  activationErrors: {
    nameError: string;
    typeError: string;
    identifierError: string;
  };
  updateErrors: (field: 'nameError' | 'typeError', value: string) => void;
  updateActivationDetails: (field: 'name' | 'identifier', value: string) => void;
  updateActivationProfileDetails: (value: {
    whtProjectId: string;
    sourceDefinitionName?: SourceDefinitionType;
    entityId: string;
    cohortId: string;
    type?: PROFILE_SOURCE_TYPES;
  }) => void;
  getActivationIdentifiers: (id: string, pathRef: string) => Promise<void>;
}

export interface ActivationReviewStoreType extends StepStore<ActivationStoreType> {
  sourceId: string;
  onNext: () => Promise<void>;
}

export interface ProfileSourcePayload {
  name: string;
  sourceType: PROFILE_SOURCE_TYPES;
  sourceDefinitionName: string;
  config: {
    whtProjectId: string;
    cohort: string;
    entity: string;
    modelPath: string;
  };
}

export interface ActivationStoreType {
  rootStore: IRootStore;

  stepsStore: StepsStore<ActivationStoreType>;

  activationDetailsStore: ActivationDetailsStoreType;

  activationConfiguration: AudienceConfigurationStore;

  activationReview: ActivationReviewStoreType;

  updateActivationCreation: (flag: boolean) => void;

  updateSteps: () => void;
}
